// extracted by mini-css-extract-plugin
module.exports = {"inputs":"OTPInput_inputs__LWxum","focusAnimation":"OTPInput_focusAnimation__qSkZ5"};